import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
// import SaveIcon from "@mui/icons-material/Save";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Stack,
  TextField,
  IconButton,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
} from "@mui/material";
// import ClearIcon from "@mui/icons-material/Clear";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import Save from "@mui/icons-material/Save";
import ExportDialogList from "./ExportDialogList";

export default function ExportDialog(props) {
  return (
    <Dialog
      fullWidth={true}
      maxWidth={"sm"}
      open={props.isOpen}
      onClose={props.onClose}
      scroll={"paper"}
    >
      <DialogTitle style={{ paddingTop: 0, paddingBottom: 0 }}>
        {`Export to PDF`}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>{`Select the settings for pdf export`}</DialogContentText>

        <Box
          noValidate
          // component="form"
          sx={{
            // display: "flex",
            // bgcolor: "primary.main",

            // flexDirection: "column",
            m: "auto",
            width: "100%",
            flexGrow: 1,
          }}
        >
          {props.exportTemplates.length > 0 && (
            <FormControl sx={{ m: 1, minWidth: 120 }} fullWidth>
              <InputLabel id="templateName-label">Saved Templates</InputLabel>
              <Select
                labelId="templateName-label"
                id="templateName-select"
                value={props.templateName}
                label="Saved Templates"
                onChange={props.handleTemplateNameChange}
              >
                {props.exportTemplates.map((template) => (
                  <MenuItem key={template.name} value={template.name}>
                    {template.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
          <ExportDialogList
            handleChecked={props.handleChecked}
            handleCheckedSection={props.handleCheckedSection}
            reportSections={props.reportSections}
            onMoveClick={props.onMoveClick}
          />

          <Stack
            direction={"row"}
            spacing={1}
            sx={{
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <TextField
              fullWidth
              id="outlined-controlled"
              label="Save as an Export Template"
              value={props.newTemplateName}
              placeholder="Template Name"
              onChange={(e) => {
                props.onNewTemplateNameChange(e.target.value);
              }}
            />

            <IconButton
              disabled={
                !props.newTemplateName ||
                props.newTemplateName.length === 0 ||
                props.reportSections.filter((s) => s.isChecked).length === 0 ||
                props.reportSections
                  .filter((s) => s.isChecked)
                  .every((s) => s.fields.filter((f) => f.checked).length === 0)
              }
              color="primary"
              aria-label="save current template"
              onClick={props.onSaveTemplate}
            >
              <Save />
            </IconButton>
          </Stack>
        </Box>
      </DialogContent>
      <DialogActions>
        <Stack>
          {/* <Typography color="error">{props.formErrorMessage}</Typography> */}
          <Stack direction={"row"} spacing={1}>
            <Button
              startIcon={<ArrowBackIcon />}
              variant="outlined"
              onClick={props.onClose}
            >
              Cancel
            </Button>

            <Button
              disabled={
                props.reportSections.filter((s) => s.isChecked).length === 0 ||
                props.reportSections
                  .filter((s) => s.isChecked)
                  .every((s) => s.fields.filter((f) => f.checked).length === 0)
              }
              startIcon={<PictureAsPdfIcon />}
              variant="contained"
              onClick={() => {
                props.onExportFeatures();
                props.onClose();
              }}
            >
              Export PDF
            </Button>
          </Stack>
        </Stack>
      </DialogActions>
    </Dialog>
  );
}
